<template>
  <div>
    <el-form>
      <el-form-item>
        图片顺序：
        <el-input style="width:50%"></el-input>
      </el-form-item>
      <el-form-item>
        图片内容：
        <el-input  type="file" style="width:50%"></el-input>
      </el-form-item>
      <el-form-item>
        状态：<el-switch
        v-model="rohs"
        active-color="#13ce66"
        inactive-color="#ff4949">
      </el-switch>
      </el-form-item>
      <el-button>保存</el-button>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'AddAdmin',
    data(){
      return {
        rohs: true,
      }
    },
    methods:{
      close (){
        this.$emit('close')
      }
    }

  }
</script>
